import useSession from 'core/hooks/use-session';
import { useStore } from 'core/store';
import { wasRenewedFromImportedLineage } from 'common/components/farm/uw-questions-form/helpers';

/**
 * #34201: gates the underwriter-only "Refresh 360Value" toggle for migrated (imported-then-renewed)
 * farm terms. When a UW enables it, the next re-rate re-pulls the 360Value to refresh Coverage A /
 * Coverage E (overriding the #33509 preservation) and lets the UW override Coverage A down to a
 * $1,000 floor with no upper cap. It must be shown ONLY to underwriters and ONLY on a migrated
 * lineage, so agents and organically-written policies never see it.
 *
 * Migrated detection reads the whole account lineage (via wasRenewedFromImportedLineage): the FE
 * surfaces the flag-less imported base term as `policy`, but the UW actually edits its renewal, which
 * carries `wasRenewedFromImportedTerm`. On the offer route the policy store is empty, so this is
 * false (new business is never migrated) and the toggle stays hidden.
 */
export const useFarmMigrationUW = () => {
  const session = useSession();
  const store = useStore();
  const policy = store?.account?.policies?.policy?.policy;
  const policies = store?.account?.policies?.list;
  return {
    canUwRefresh360Value: Boolean(session.canApproveUWReview && wasRenewedFromImportedLineage(policy, policies))
  };
};
